import React from "react";

const InfoSvg = ({ color, size }: { color: string; size?: number }) => {
  return (
    <svg
      width={size ?? "16"}
      height={size ?? "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zm0 14.4A6.408 6.408 0 0 1 1.6 8c0-3.536 2.864-6.4 6.4-6.4 3.536 0 6.4 2.864 6.4 6.4 0 3.536-2.864 6.4-6.4 6.4z"
        fill={color}
      />
      <path
        d="M8 4.8c.44 0 .8.36.8.8v3.2a.8.8 0 0 1-1.6 0V5.6c0-.44.36-.8.8-.8zm0 6.4a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6z"
        fill={color}
      />
    </svg>
  );
};

export default InfoSvg;
